<template>
  <div>
    <template v-if="info !== null">
      <b-row>
        <b-col sm="12">
          <div class="carousel-wrapper clearfix">
            <img :src="info.images[0].url" class="print-only"  style="height:250px;" v-if="info.images.length"/>
            <b-card no-body class="noPrint">
              <b-carousel
                id="carousel"
                controls
                indicators
                 v-if="info.images.length"
                >
                <b-carousel-slide v-for="(image,imageIndex) in info.images" :key="imageIndex">
                  <template slot="img">
                    <img :src="image.url" class="img-fluid w-100 d-block carousel-img" />
                  </template>
                </b-carousel-slide>
              </b-carousel>
              <img v-else src="@/assets/images/backgrounds/default-image.jpg" style="height:250px;" />
              <b-card-footer class="bg-light noPrint" v-if="info.files.length">
                <h6 class="modal-title border-bottom mb-2">Fisiere atasate</h6>
                <b-list-group v-for="(file, fileIndex) in info.files" :key="'file' + fileIndex" flush>
                  <b-list-group-item target="_self" :href="file.url" class="py-1 pl-1 bg-light">
                    <b-icon icon="file-earmark-text" scale="1.3" class="mr-1 text-danger"/>
                    <b>{{ file.label }}</b>
                  </b-list-group-item>
                </b-list-group>
              </b-card-footer>
            </b-card>
          </div>
          <div>
            <h3 class="font-weight-bold" style="display: inline;">{{ info.name }}</h3>
            <sup  class="print-only" v-if="starsIsNumber">
              <span v-for="star in stars" :key="star">
                <b-icon icon="star-fill" font-scale="1.3"></b-icon>
              </span>
            </sup>
            <sup class="d-inline-block noPrint" v-if="starsIsNumber">
              <div v-for="star in stars" :key="'star' +  star" class="stars"></div>
            </sup>
            <span v-if="!starsIsNumber" class="text-warning">{{ info.class }}</span>
            <h6 class="d-inline ml-2 text-info">{{info.extraClass}}</h6>
            <template v-if="info.description">
              <h6 class="modal-title mt-2"><b>Descriere</b></h6>
              <p style="text-align:justify;" class="mb-0" v-if="info.descriptionIsHtml" v-html="info.description"></p>
              <p style="text-align:justify; white-space: pre-line;" class="mb-0" v-else>{{ info.description }}</p>
            </template>
          </div>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col sm="12" class="margin-0">
          <div v-for="(desc, descIndex) in info.descriptions" :key="'desc' + descIndex">
            <h6 class="modal-title">{{ desc.label }}</h6>
            <span v-html="desc.text" ></span>
          </div>
        </b-col>
        <b-col>
          <small v-if="info.url">
            <a :href="info.url" target="_blank">{{ info.url }}</a>
          </small>
        </b-col>
      </b-row>
    </template>
    <b-row v-else>
      <b-col md="12" class="text-center pt-3">
        <b-aspect aspect="10">
          <b-spinner type="grow" label="Se incarca"></b-spinner>
          <p>Va rugam asteptati...</p>
        </b-aspect>
      </b-col>
    </b-row>
  </div>
</template>

<style scoped>
  .print-only {
    display: none!important;
  }
</style>

<script>
export default {
  name: 'HotelInfo',
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  computed: {
    starsIsNumber () {
      // Try converting the string to an integer
      const intValue = parseInt(this.info.class, 10) // Base 10 for decimal system

      // Check if it's a valid integer and not NaN
      return !isNaN(intValue) && Number.isInteger(intValue)
    },
    stars () {
      return parseInt(this.info.class, 10)
    }
  }
}
</script>
